import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import '../../assets/styles/components/news/news.scss';
import { stockActions } from '../../actions/trading/stock.action';
import { ACTION_TYPE, NEWS_TYPE } from "../../constants/w-socket";
import { WS_LANG_KEY } from '../../constants/app';
import { utilsFunction, Converter } from "../../helpers/functions";
import moment from 'moment';
import { settingConfigs } from '../../configurations';
import LoadingLayer from '../Spinner/LoadingLayer';
import { openNewsDetailDialog } from '../../actions/app/dialog.action'
import { LOADING_TYPE } from '../../constants/app';
import NoRow from '@/components/DataTable/CustomNoRow';

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newData: [],
      load: false
    }
  }

  componentDidMount() {
    this.getNewsData()
  }

  componentDidUpdate(prevProps, prevState) {
    const { marketParams } = this.props;
    const { marketID, stockCode } = marketParams;
    if (marketParams && marketParams !== prevProps.marketParams) {
      if (utilsFunction.instrumentIDZeroPadding(stockCode) !== utilsFunction.instrumentIDZeroPadding(prevProps.marketParams.stockCode)) {
        this.getNewsData()
      }
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  getNewsData() {
    this.setState({
      load: true,
      newData: []
    })
    const { language, marketParams } = this.props;
    const { marketID, stockCode } = marketParams;
    if (!(marketID && stockCode)) return
    const params = {
      subscribe: null,
      msgType: ACTION_TYPE.NEWS,
      category: NEWS_TYPE.ANNOUNCEMENT,
      datetime: moment().format(settingConfigs.LONG_DATE),
      count: 8,
      symbols: [
        {
          exchangeID: Converter.mappingWebSocketMarket(marketID),
          key: Converter.mappingStockCode(stockCode)
        }
      ],
      language: language.lang !== 'zh_CN' ? utilsFunction.switchToolTipsLanguage(language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC) : WS_LANG_KEY.TC
    }
    this.props.getNews(params, res => {
      this.setState({
        load: false
      })
      if (res.rtnCode) return
      let data = this.state.newData;
      if (data.length == 0) {
        data.push(res)
      } else {
        if (data.findIndex(item => item.id == res.id) == -1) {
          data.push(res)
        }
      }
      this.setState({
        newData: data
      })
    })
  }

  render() {
    const { language, isMobile } = this.props;
    const { newData, load } = this.state;

    return (
      <React.Fragment>
        <div className={classnames('news-container', isMobile && 'news-mobile-container')}>
          <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
          <header>{language.common_news}</header>
          {
            !load && Array.isArray(newData) && newData.length == 0 && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }} />
          }
          <section>
            {newData.map((news, index) =>
              <div onClick={() => openNewsDetailDialog(newData, news.id)} key={news.id + index} className="item">
                <span className="stock-code">[ {news.source} ]</span>
                <span className="title">{news.headline}</span>
                <span className="time">{moment(news.releaseTime).format(settingConfigs.LONG_DATE)}</span>
              </div>
            )}
          </section>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    isMobile: state.app.isMobile,
    marketParams: state.trade.marketParams
  }),
  dispatch => ({
    getNews: (p, c) => stockActions.getNewsAction(p, c)
  })
)(News)